/* Add-to-cart total, sticky bar and gift tiles in the visitor's currency (v49).
   The total is built from the store's real local unit prices (window.IF_LOCAL)
   minus the bundle discount at the live rate, so it equals the cart to the
   cent. #if-total keeps the raw USD number for the other scripts; it is
   hidden and a converted copy is shown instead. */
(function(){
var R=1,C='USD';
try{if(window.Shopify&&Shopify.currency){R=parseFloat(Shopify.currency.rate)||1;C=Shopify.currency.active||'USD';}}catch(e){}
var LOCAL=!(R===1&&C==='USD');
var fmt;try{fmt=new Intl.NumberFormat(document.documentElement.lang||navigator.language||'en',{style:'currency',currency:C});}catch(e){fmt={format:function(v){return C+' '+v.toFixed(2);}};}
var USD_B={1:26.95,2:46.95,3:61.95};
function r2(v){return Math.round(v*100)/100;}
function conv(usd){if(!LOCAL)return usd;if(window.IF_CONV)return window.IF_CONV(usd);return r2(usd*R);}
function money(usd){return LOCAL?fmt.format(conv(usd)):'$'+usd.toFixed(2);}
function qty(){var rows=document.getElementById('if-bundlerows');if(rows){for(var i=0;i<rows.children.length;i++){var st=rows.children[i].getAttribute('style')||'';if(st.indexOf('#FF4D14')>-1&&st.indexOf('border:2px solid #FF4D14')>-1)return i+1;}}var h=document.getElementById('if-bundles');if(h){var b=h.querySelectorAll('button');for(var k=0;k<b.length;k++){if((b[k].style.borderColor||'').indexOf('255, 77, 20')>-1)return k+1;}}return 1;}
function totalLocal(v){
if(!LOCAL)return '$'+v.toFixed(2);
var q=qty(),base=USD_B[q]||USD_B[1];
var bl=window.IF_BUNDLE_LOCAL?window.IF_BUNDLE_LOCAL(q):null;
if(bl===null||bl===undefined)return fmt.format(conv(v));
var extra=r2(v-base),out=bl;
if(extra>0.009){var l=window.IF_LOCAL||{};if(Math.abs(extra-22.95)<0.02&&l.goggles)out+=l.goggles/100;else out+=r2(extra*R);}
return fmt.format(r2(out));
}
var css=document.createElement('style');
css.textContent='#if-add #if-total{display:none!important}#if-add .ifc-tot{display:inline}'+
'.ifc-rvw{background:#FF4D14!important;border-color:#FF4D14!important;color:#fff!important;box-shadow:0 8px 20px rgba(255,77,20,.28)!important;transition:transform .15s ease,background .2s ease!important}'+
'.ifc-rvw:hover{background:#E63F0A!important}.ifc-rvw:active{transform:scale(.97)}'+
'#ifc-rvw-end{display:flex;justify-content:center;margin:22px 0 4px}';
document.head.appendChild(css);
function atc(){
var b=document.getElementById('if-add'),t=document.getElementById('if-total');
if(!b||!t)return null;
var v=parseFloat((t.textContent||'').replace(/[^0-9.]/g,''));
if(!isFinite(v))return null;
for(var i=0;i<b.childNodes.length;i++){var n=b.childNodes[i];if(n.nodeType===3&&n.nodeValue.indexOf('$')>-1)n.nodeValue=n.nodeValue.replace('$','');}
var s=b.querySelector('.ifc-tot');
if(!s){s=document.createElement('span');s.className='ifc-tot';t.parentNode.insertBefore(s,t.nextSibling);}
var want=totalLocal(v);if(s.textContent!==want)s.textContent=want;
return want;
}
function sticky(label){var sb=document.getElementById('ifs-btn');if(!sb||!label)return;var want='Add to cart \u2014 '+label;if(sb.textContent!==want)sb.textContent=want;}
var MONEY=/\$\s?(\d+(?:\.\d{2})?)/g;
function texts(root){
if(!root||!LOCAL)return;
var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;
while((n=w.nextNode())){
var t=n.nodeValue;if(!t||t.indexOf('$')<0)continue;
var p=n.parentNode;if(!p||p.id==='if-total'||p.closest('script,style,#if-add'))continue;
var o=t.replace(MONEY,function(m,num){var v=parseFloat(num);return isNaN(v)?m:fmt.format(conv(v));});
if(o!==t)n.nodeValue=o;
}}
function gifts(){
var row=document.getElementById('if-gift-row');if(!row)return;
[].forEach.call(row.children,function(tile){
var txt=tile.textContent||'',val=null,key=null;
if(/Snow Gloves/i.test(txt)){val=14.95;key='gloves';}else if(/Mystery Mask/i.test(txt)){val=26.95;key='mystery';}
if(!val)return;
var l=window.IF_LOCAL||{};var lab=LOCAL?fmt.format(l[key]?l[key]/100:conv(val)):'$'+val.toFixed(2);
[].forEach.call(tile.querySelectorAll('span'),function(s){
if(s.children.length)return;var t=s.textContent||'';
if(/value\s*$/i.test(t)&&/FREE/i.test(t)){var want='FREE \u00b7 '+lab+' value';if(t!==want){s.textContent=want;s.setAttribute('data-if-cur','1');}}
});
});
}
function reviews(){
var rv=document.getElementById('reviews');if(!rv)return;
var btn=null;
[].forEach.call(rv.querySelectorAll('button,a'),function(b){if(!btn&&!b.id.match(/^ifc-/)&&/write a review/i.test(b.textContent||''))btn=b;});
if(!btn)return;
btn.classList.add('ifc-rvw');
if(!document.getElementById('ifc-rvw-end')){
var list=document.getElementById('iflist')||document.getElementById('if-reviews');
var host=document.createElement('div');host.id='ifc-rvw-end';
var c=document.createElement('button');c.type='button';c.id='ifc-rvw-btn';c.className=btn.className+' ifc-rvw';
c.setAttribute('style',btn.getAttribute('style')||'');
c.style.padding=c.style.padding||'14px 26px';c.style.borderRadius=c.style.borderRadius||'12px';c.style.fontWeight='800';c.style.fontSize=c.style.fontSize||'16px';c.style.cursor='pointer';c.style.border='0';
c.textContent='Write a review';
c.addEventListener('click',function(e){e.preventDefault();btn.click();});
host.appendChild(c);
(list&&list.parentNode?list.parentNode:rv).appendChild(host);
}
}
function run(){var lbl=atc();sticky(lbl);gifts();texts(document.getElementById('if'));texts(document.getElementById('if-sticky'));reviews();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
setInterval(run,350);
})();
